/** 酒店分包业务文案 — 中文 */
export default {
  hotel: {
    nav: {
      home: '酒店首页',
      list: '酒店列表',
      detail: '酒店详情',
      order: '创建订单',
      search: '选择地址',
      evaluate: '评价',
      facilities: '设施服务',
      highlights: '亮点/设施',
      cart: '收藏',
      intlSearch: '国际酒店选择地址',
      intlCitySearch: '选择国际城市',
      intlOrderDetail: '国际酒店订单详情',
    },
    common: {
      domestic: '国内',
      international: '国际',
      checkIn: '入住',
      checkOut: '离店',
      checkInOutSame: '入住/离店',
      nights: '{count}晚',
      nightOne: '共{count}晚',
      priceStar: '价格星级',
      searchHistory: '搜索记录',
      clear: '清空',
      done: '完成',
      cancel: '取消',
      retry: '重试',
      locating: '定位中…',
      locationFailedPrefix: '定位未成功，已默认',
      locatedTo: '已定位到',
      searchPlaceholderDomestic: '位置/品牌/酒店',
      searchPlaceholderIntl: '城市/酒店名称',
      roomCount: '{room}间房 {adult}成人 {child}儿童',
      featured: '精选',
      topHotels: '上榜酒店',
      guessYouLike: '猜你喜欢',
      reputationHot: '口碑&热卖',
      hotArea: '热门区域',
      userChoiceRate: '{rate} | 用户选择',
      installmentFree: '分期免息',
      support40Banks: '支持40家银行',
      queryHotel: '酒店查询',
      searchHotel: '查询酒店',
      proximitySearch: '附近搜索',
      tabHome: '首页',
      tabOrders: '订单',
      tabMine: '我的',
      currentLocation: '当前位置',
      adBannerTitle: '分期无忧·精选特惠·安心入住',
      locationFailedRetry: '定位失败，请稍后重试',
      cityType: '城市',
      china: '中国',
      searchResults: '搜索结果',
      hotDomesticCities: '国内热门城市',
      currentLocationLabel: '当前定位',
      searchCityPlaceholder: '搜索城市名称',
      service: '客服',
      viewRoomTypes: '查看房型',
      priceFrom: '起',
      useful: '有用',
      filter: '筛选',
      all: '全部',
      withMedia: '有图·视频',
      badReview: '差评',
      noPhone: '暂无联系电话',
      pleaseLogin: '请先登录',
      unfavoriteSuccess: '取消收藏',
      favoriteSuccess: '收藏成功',
      loadSuccess: '加载成功',
      loadFailedRetry: '加载失败，请重试',
      shareUnlock: '点击解锁｜{name}酒店特惠',
      taxIncluded: '含税',
      noPrice: '暂无报价',
      noMoreData: '没有更多数据了',
      reviewsCount: '{count}条评价',
      scoreUnit: '{score}分',
      tabFavorite: '收藏',
      tabMyOrders: '我的订单',
      checkInLabel: '入住',
      checkOutLabel: '离店',
      totalNights: '共{count}晚',
      nightBadge: '{count}晚',
      clearHistory: '清空',
    },
    star: {
      below2: '2星及以下',
      star3: '3星',
      star4: '4星',
      star5: '5星',
      economy: '经济',
      comfort: '舒适',
      upscale: '高档',
      luxury: '豪华',
      below2List: '2钻/星及以下',
      star3List: '3钻/星',
      star4List: '4钻/星',
      star5List: '5钻/星',
    },
    components: {
      selectDate: {
        title: '选择日期',
      },
      houseDetail: {
        viewAllFacilities: '查看全部设施',
        collapse: '收起',
        policyAndService: '政策与服务',
        beijingTime: '北京时间',
        cancelFee: '取消费用',
        nonRefundableNotice: '若未入住将收取您¥{amount}。订单需等酒店或供应商确认后生效，订单确认结果以0息游短信、通知为准，如订单不确认将全额退款至您的付款账户。',
        cancellableNotice: '{rule}，超过后则不可取消，若未入住将收取您￥{amount}。',
        instantConfirmDesc: '预订此房型后可快速确认订单',
        payOnlineDesc: '房费需提前支付，可使用银行卡，云闪付等进行付款',
        costStayRange: '{start}-{end} {nights}',
        roomFee: '房费',
        packageTotal: '套餐合计',
        perRoomPerNight: '每间每晚',
        roomNightPrice: '{room}间{night}晚￥{amount}',
        roomNightSummary: '{room}间 · {night}晚',
        book: '订',
        avgPriceSummary: '{room}间{night}晚 均',
        floorSuffix: '层',
        afterBookingSuccess: '预订成功后',
        free: '免费',
      },
      selectNum: {
        title: '选择客房和入住人数',
        rooms: '间数',
        adults: '成人数',
        children: '儿童数',
        childAgeHint: '0-17岁',
      },
      filterPrice: {
        title: '选择价格/星级',
        price: '价格',
        star: '星级',
        clear: '清空',
        done: '完成',
      },
    },
    positioning: {
      permissionTitle: '定位权限',
      permissionContent: '需要获取您的地理位置，请在设置中开启定位权限',
      confirmKnow: '知道了',
      geocodeFailed: '逆地理编码失败，请稍后重试',
      cityCodeFailed: '城市代码查询失败',
    },
    list: {
      keywordPlaceholder: '关键词搜索',
      searchNameAddress: '搜索酒店名称、地址等',
      unionOrderTip: '您正在为{type}加订酒店',
      stayShort: '住',
      leaveShort: '离',
      roomsUnit: '{count}间房',
      guestsUnit: '{count}人',
      roomGuestCompact: '{room}间·{adult}人',
      roomGuestsSummary: '{room}间房 {adult}成人 {child}儿童',
      station: '站点',
      locationDistance: '位置距离',
      priceStar: '价格/星级',
      price: '价格',
      star: '星级',
      bookingInfo: '预订信息',
      locate: '定位',
      distanceFromTarget: '距{target}直线{distance}km',
      you: '您',
      smartSort: '智能排序',
      priceAsc: '价格升序',
      priceDesc: '价格降序',
      starAsc: '星级升序',
      starDesc: '星级降序',
      distanceAsc: '距离升序',
      priceUp: '价格↑',
      priceDown: '价格↓',
      starUp: '星级↑',
      starDown: '星级↓',
      locationArea: '位置区域',
      straightDistance: '直线距离',
      sort: '排序',
      bedType: '床型',
      breakfast: '早餐',
      hotelBadge: '酒店标志',
      filterLoadFailed: '筛选条件加载失败',
      bedSingle: '单床',
      bedTwin: '双床',
      bedKing: '大床',
      bedMulti: '多床',
      bedKingTwin: '大/双',
      breakfastSingle: '单早',
      breakfastDouble: '双早',
      breakfastBed: '床位早',
      breakfastNone: '无早',
      badgeGold: '金牌',
      badgeSilver: '银牌',
      badgeBronze: '铜牌',
      unionOrderTypePlane: '机票',
      unionOrderTypeIntlPlane: '国际机票',
      unionOrderTypeTrain: '火车票',
      unionOrderTypeFallback: '订单',
      unionOrderFlightTrip: '{dep}到{arr}的{type}',
      unionOrderTrainTrip: '{from}到{to}的{type}',
      unionOrderDefault: '行程',
      locationTypeMetro: '地铁线路',
      locationTypeTrainStation: '火车站',
      locationTypeUniversity: '大学',
      locationTypeHospital: '医院',
      locationTypeAttraction: '景点',
      locationTypeAirport: '机场',
      locationTypeBusStation: '汽车站',
      geocodeAddressEmpty: '地址不能为空',
      geocodeMapNotInit: '高德地图API未初始化',
      geocodeNotFound: '未找到对应的位置信息',
      geocodeFailed: '地理编码失败',
      unionOrderCityLocked: '联合订单模式下不能修改城市',
      enableLocation: '请打开定位服务',
      locateFailed: '定位失败，请稍后重试',
    },
    order: {
      roomDetail: '房型详情',
      nightsBadge: '{count}晚',
      instantConfirm: '立即确认',
      bookingInfo: '订房信息',
      roomsUnit: '{count}间',
      guestName: '住客姓名',
      guestNamePlaceholder: '每间需填1位入住人姓名',
      guestInfo: '住客信息',
      nameGuideTitle: '姓名填写说明：',
      lastNameGuide: '姓：用英文或中文拼音，如li',
      firstNameGuide: '名：用英文或中文拼音，如hao',
      roomGuestTitle: '第{index}间房入住人信息',
      fullName: '全名',
      fullNamePlaceholder: '请输入完整姓名',
      fullNamePlaceholderIntl: '请输入完整姓名（拼音/英文）',
      lastName: '姓',
      lastNamePlaceholder: '如：li',
      firstName: '名',
      firstNamePlaceholder: '如：hao',
      contactPhone: '联系手机',
      contactPhonePlaceholder: '请输入联系手机',
      moreDiscount: '更多优惠',
      coupon: '优惠券',
      couponAvailable: '{count}张可用',
      couponNone: '暂无可用',
      bankPayLimit: '仅限{bank}支付可用',
      designatedBank: '指定银行',
      specialRequirements: '特殊要求',
      liftDistance: '电梯远近',
      smokeFree: '是否需要无烟处理',
      moreRequirements: '更多入住要求',
      hotelTryBest: '酒店将尽力满足您的所有要求，但不保证均会成功',
      agreePrefix: '我已阅读并同意',
      privacyTitle: '个人信息授权说明',
      privacyPopupTitle: '个人信息授权说明',
      payOnline: '在线付',
      priceDetails: '费用明细',
      priceDetailsShort: '费用明细',
      payNow: '立即支付',
      installmentPeriod: '{count}期',
      totalDiscount: '共减￥{amount}',
      requirePopupTitle: '特殊要求',
      requireTransmit: '我们会将您的要求传达给酒店',
      requireTryBest: '酒店将视住宿情况尽量为您安排，但不保证均会成功',
      envRequirements: '环境、服务等要求',
      requirePlaceholder: '提出您的更多特殊要求',
      payOnlineDetail: '在线支付',
      payLimit: '支付限制：仅限{bank}支付可用',
      privacyIntro: '尊敬的用户，感谢您使用0息游的住宿预订业务，具体的服务将由最终的服务提供方向您提供。',
      privacyBody: "您理解，0息游需将订单信息确认页中涉及的您勾选的住宿产品信息与您输入或勾选的个人信息（视预订住宿产品资源不同，所必需的个人信息有所差异，一般会包括姓名、联系方式，可能也会包含您在预订过程中主动提供的身份证件信息、信用卡信息等），通过传输至服务提供方系统或由其访问0息游系统的方式（当您预订境外酒店时，前述信息会跨境传输至境外服务提供方或由其跨境访问0息游系统），进行自动化订单处理或者人工订单处理，以供其核实您的身份、确认您的订单，并最终为您提供住宿服务。您可以通过酒店详情页面查阅境内或境外酒店名称和联系方式。若您购买的是住宿（含演出票务）套餐产品，您理解，为维护演出票务市场销售秩序，演出项目通常需要实名购票，您的购票订单信息（一般会包括姓名、证件号、手机号）将提供给主办方及/或其委托的代理商、票务系统服务商（合称“供应商”）用于出票。具体供应商信息可通过演出项目详情页面查阅。如您购买的票品为纸质票品需通过物流快递交付给您的，您还需提供您的票品配送信息（包括您的收件人姓名、联系电话及收货地址）。为保证您购买的演出票品能够顺利准确的交付给您，我们会向合作的物流公司、供应商提供相关配送信息，用于完成交付目的。在提供有关信息前，0息游将严格执行《中华人民共和国个人信息保护法》以及0息游《个人信息保护政策》的规定，要求有关服务提供方切实履行个人信息保护义务，仅就提供服务之目的处理您的个人信息，不得擅自转移、共享、提供、出售或基于其他目的处理您的个人信息。我们还设立了个人信息保护专职部门，有关您个人信息的权利请求，包括个人信息出境场合向境外接收方主张个人信息权利的请求，可以发送邮件至个人信息保护负责人的邮箱privacy{'@'}ctrip.com与我们联系。请您再次审慎核实确认您勾选的产品信息与您输入或勾选的个人信息；您同意0息游基于为您提供服务之目的，向有关服务提供方提供您的个人信息；如果订单信息中包含未成年人信息的，表示您作为订单中未成年人的监护人（或已征得该未成年人监护人的同意），有权使用该未成年人信息提交订单，同意平台为提供产品或服务的目的，处理未成年人的个人信息。",
      phoneProtectTitle: '号码保护服务说明：',
      phoneProtect1: '1、为了保证您的交易安全、保障服务体验、处理服务纠纷，您在部分订单的预订和履行过程中拨打或者接听商家电话时，我们将可能为您开启号码保护，商家无法查看到您的真实电话/手机号码。',
      phoneProtect2: '2、号码保护服务的开通场景如下：',
      phoneProtect2a: '（1）在对应订单服务过程中，我们会将您的联系号码转为虚拟号后提供给商家，商家通过虚拟号联系您后，您也可通过直接回拨方式用虚拟号联系商家；',
      phoneProtect2b: '（2）当您通过0息游页面的虚拟号码/网络电话功能拨打商家电话时，将享受号码保护服务。',
      phoneProtect3: '3、使用号码保护的通话在拨打或接听过程中都可能会被录音。0息游将切实保障通信双方的隐私安全，将录音信息存储在中国境内，各方无法自行下载、调取；录音信息仅在以下场景时会被使用:',
      phoneProtect3a: '（1）当用户、商家间出现服务纠纷时，0息游调取并使用录音信息作为解决纠纷的参考依据；另为预防风险、保护各方安全，0息游可能会对录音信息进行分析；',
      phoneProtect3b: '（2）有权机关依法定程序调取，或被录音的一方持司法机关出具的法律文件依法调取。',
      phoneProtect4: '4、号码保护的服务提供可能会出现服务故障，则您的真实手机号将有可能展示给商家；此外，受网络状态稳定性、适用的法律法规等限制，可能会出现录音/存储失败、无法录音等情形。',
      selectCoupon: '选择优惠券',
      loadingCoupons: '获取优惠券中...',
      noCoupons: '暂无可用优惠券',
      skipCoupon: '不使用优惠券',
      discountUnit: '折',
      validUntil: '有效期至：{date}',
      liftFar: '远离电梯',
      liftNear: '靠近电梯',
      envSmokeFree: '需要无烟处理',
      envQuiet: '安静',
      envHighFloor: '高楼层',
      envNoCorner: '不要角落房',
      couponFetchFailed: '获取优惠券失败',
      couponSelected: '已选择优惠券，优惠￥{amount}',
      couponSelectFailed: '选择优惠券失败',
      couponCalcFailed: '计算优惠金额失败',
      couponCancelled: '已取消优惠券',
      noThreshold: '无门槛',
      couponReduce: '满{min}减{price}',
      couponInstantReduce: '立减{price}元',
      couponDiscount: '满{min}享{discount}折',
      couponInstantDiscount: '{discount}折优惠',
      couponDefault: '优惠券',
      agreePrivacyFirst: '请阅读并同意个人信息授权说明',
      guestPerRoom: '每间需填写1位入住人',
      fillContact: '请填写联系人和电话',
      completeGuestRoom: '请完善第{index}间房入住人信息',
      guestNameEnglishOnly: '第{index}间房的姓和名仅限英文填写',
      fillPhone: '请填写联系手机',
      createOrderReturning: '即将返回酒店详情',
      createOrderFailed: '订单创建失败',
      createOrderHotelLabel: '预订酒店',
      createOrderReturningIn: '{seconds} 秒后返回酒店详情',
      createOrderReturnNow: '立即返回',
      today: '今天',
      tomorrow: '明天',
      dayAfterTomorrow: '后天',
      weekdaySun: '周日',
      weekdayMon: '周一',
      weekdayTue: '周二',
      weekdayWed: '周三',
      weekdayThu: '周四',
      weekdayFri: '周五',
      weekdaySat: '周六',
      monthDay: '{month}月{day}日',
    },
    detail: {
      noRoomData: '暂无房型数据',
      bookOnlinePay: '在线付.订',
      book: '订',
      addCart: '加入购物车',
      addingCart: '添加中',
      addCartSuccess: '已加入购物车',
      addCartFailed: '加入购物车失败，请稍后重试',
      cartQuoteInvalid: '报价信息不完整，请重新选择',
      cartQuoteUpdated: '报价已更新，请重新选择',
      loginFailed: '登录页面打开失败，请稍后重试',
      reviewsCount: '{count}条点评',
      commentScoreEmptyTitle: '暂无评分',
      commentScoreEmptyDesc: '期待您的入住，留下宝贵的评价',
      guestRecommend: '旅客推荐',
      facilities: '酒店设施',
      popularFacilities: '热门设施',
      viewAll: '查看全部',
      map: '地图',
      roomFilter: '筛选',
      bestSeller: '本店销量No.1',
      guessYouLike: '猜您喜欢',
      photosCount: '{count}张',
      avgPrice: '均￥',
      viewMorePrices: '查看其他{count}个价格',
      noRooms: '暂无房型',
      noRoomTypesSoldOut: '该酒店已售罄',
      soldOutLeadSeparator: '，',
      soldOutSeeYouMayLike: '看看您可能喜欢的酒店吧',
      allGuestReviews: '全部住客点评',
      greatReviews: '棒',
      goodRate: '好评率{rate}',
      similarGuestReviews: '偏好相似住客点评',
      viewAllReviews: '查看全部点评',
      viewMediaReviews: '查看图片/视频点评',
      guestQa: '住客问答',
      ask: '问',
      viewAllAnswers: '查看全部{count}条回答',
      hotelIntro: '酒店介绍',
      noIntro: '暂无介绍',
      facilitiesService: '设施服务',
      facilitiesScore: '设施{score}',
      viewAllFacilities: '查看全部{count}项设施',
      hotelPolicy: '酒店政策',
      checkInOutTime: '入离时间',
      checkInAfter: '入住时间：14:00后',
      checkOutBefore: '退房时间：12:00前',
      childrenPolicy: '欢迎携带儿童入住',
      extraBed: '所有房型可加床、可提供婴儿床',
      expandAllPolicy: '展开全部政策',
      youMayLike: '您可能喜欢的酒店',
      locationHighlightsTitle: '位置亮点',
      surroundingsTitle: '位置周边',
      distanceFromYou: '距您{distance}米 ·',
      hotelPhone: '酒店电话',
      loadFailed: '加载失败',
      loadFailedDesc: '网络异常或服务器繁忙，请稍后重试',
      reload: '重新加载',
      childSuffix: '孩',
      roomGuestSummary: '{room}间·{adult}人',
      indicationCover: '封面',
      indicationReviews: '点评',
      indicationAlbum: '相册',
      ratingSuperb: '超棒',
      ratingGreat: '棒',
      ratingVeryGood: '很好',
      ratingGood: '好',
      ratingOk: '不错',
      ratingFair: '还好',
      distanceStraight: '距您直线{distance}{unit}',
      nightChip: '{count}晚',
      roomGuestCompact: '{room}间·{adult}人',
    },
    evaluate: {
      tabAllGuests: '全部住客{score}',
      tabSimilarGuests: '与您偏好相似住客{score}',
      ratingGood: '很好',
      scoreExplanation: '评分说明',
      hygiene: '卫生',
      environment: '环境',
      service: '服务',
      facilities: '设施',
      dimensionScore: '{name}{score}',
      newReviewer: '点评新星',
      checkInMeta: '{month}入住 | 发布与{place}',
      familyTrip: '家庭亲子',
    },
    highlights: {
      openingTime: '开业时间',
      roomCount: '房间数量',
      roomsCount: '{count}间',
      renovationTime: '装修时间',
      starRating: '酒店星级',
      tabHighlights: '酒店亮点',
      albumItem: '{label}（{count}）',
    },
    facilities: {
      subtitle: '了解酒店的完整配套设施',
      hotelEnvironment: '酒店环境',
      detailsTitle: '设施详情',
      lowestPrice: '最低价格',
      pictureTypes: {
        restaurant: '餐厅',
        leisure: '休闲',
        meetingRoom: '会议室',
        multiFunction: '多功能厅',
        exterior: '外观',
        lobby: '大堂/接待台',
        fitness: '健身/娱乐',
        uncategorized: '未分类',
        lounge: '酒廊/酒吧',
        other: '其他',
        publicArea: '公共区域',
        nearbyAttractions: '周边景点',
      },
      categories: {
        transport: '交通服务',
        frontDesk: '前台服务',
        general: '通用设施',
        publicFacilities: '公共设施',
        children: '儿童设施',
        business: '商务服务',
        accessibility: '无障碍设施服务',
        sports: '运动',
        convenience: '便利设施',
        entertainment: '娱乐活动设施',
        childrenService: '儿童设施服务',
        toiletries: '洗浴用品',
        transportFacility: '交通设施',
        networkComm: '网络与通讯',
        foodDrink: '食品饮品',
        roomLayout: '客房布局和家具',
        roomLayoutAlt: '客房布局',
        network: '网络',
        outdoorView: '室外景观',
        otherService: '其他服务',
        publicZone: '公共区',
        leisureRecreation: '休闲娱乐',
        dining: '餐饮服务',
        wellness: '康体设施',
        security: '安全与安保',
        mediaTech: '媒体科技',
        roomFacilities: '客房设施',
        kitchen: '厨房用品',
        accessibilityAlt: '无障碍设施',
        cleaning: '清洁服务',
        bathroom: '卫浴设施',
      },
    },
    map: {
      routeTooFar: '距离太远，无法规划路线',
      routeNotFound: '无法找到可行路线',
      routePlanFailed: '路线规划失败，请稍后重试',
      routeInvalid: '无法规划路线，请检查位置信息',
      routeNetworkError: '网络错误，路线规划失败',
      routeShown: '已显示完整路线',
      routeEmpty: '暂无路线信息',
      destExpanded: '已展开目的地信息',
      destCollapsed: '已收起目的地信息',
      panelExpanded: '已展开导航面板',
      panelCollapsed: '已收起导航面板',
      modeSwitched: '切换到{mode}模式',
    },
  },
}
